/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GetWebsitePageParams,
  PaginatedWebsitePages,
  SchemaValidationErrorResponse,
  WebsitePage,
  WebsitePageInput
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Page
 */
export const createWebsitePage = (

 signal?: AbortSignal
) => {


      return axiosClient<WebsitePage>(
      {url: `/website/pages`, method: 'POST', signal
    },
      );
    }




export const getCreateWebsitePageMutationKey = () => ['createWebsitePage'] as const;

export const getCreateWebsitePageMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWebsitePage>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createWebsitePage>>, TError,void, TContext> => {

const mutationKey = getCreateWebsitePageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWebsitePage>>, void> = () => {


          return  createWebsitePage()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWebsitePageMutationResult = NonNullable<Awaited<ReturnType<typeof createWebsitePage>>>

    export type CreateWebsitePageMutationError = ErrorType<void>


    /**
 * @summary Create Page
 */
export const useCreateWebsitePage = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWebsitePage>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createWebsitePage>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateWebsitePageMutationOptions(options), queryClient);
    }
    /**
 * @summary List of Pages
 */
export const listWebsitePages = (

 signal?: AbortSignal
) => {


      return axiosClient<PaginatedWebsitePages>(
      {url: `/website/pages`, method: 'GET', signal
    },
      );
    }




export const getListWebsitePagesQueryKey = () => {
    return [
    'website','pages'
    ] as const;
    }


export const getListWebsitePagesQueryOptions = <TData = Awaited<ReturnType<typeof listWebsitePages>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWebsitePages>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListWebsitePagesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listWebsitePages>>> = ({ signal }) => listWebsitePages(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listWebsitePages>>, TError, TData>
}

export type ListWebsitePagesQueryResult = NonNullable<Awaited<ReturnType<typeof listWebsitePages>>>
export type ListWebsitePagesQueryError = ErrorType<void>


/**
 * @summary List of Pages
 */

export function useListWebsitePages<TData = Awaited<ReturnType<typeof listWebsitePages>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listWebsitePages>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListWebsitePagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Page
 */
export const deleteWebsitePage = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/website/pages/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteWebsitePageMutationKey = () => ['deleteWebsitePage'] as const;

export const getDeleteWebsitePageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWebsitePage>>, TError,DeleteWebsitePageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteWebsitePage>>, TError,DeleteWebsitePageMutationVariables, TContext> => {

const mutationKey = getDeleteWebsitePageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWebsitePage>>, DeleteWebsitePageMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteWebsitePage(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteWebsitePageMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWebsitePage>>>

    export type DeleteWebsitePageMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteWebsitePageMutationVariables = {id: string}

    /**
 * @summary Delete Page
 */
export const useDeleteWebsitePage = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWebsitePage>>, TError,DeleteWebsitePageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteWebsitePage>>,
        TError,
        DeleteWebsitePageMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteWebsitePageMutationOptions(options), queryClient);
    }
    /**
 * @summary Page Details
 */
export const getWebsitePage = (
    id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetWebsitePageParams>,
 signal?: AbortSignal
) => {
      id = toValue(id);
params = toValue(params);

      return axiosClient<WebsitePage>(
      {url: `/website/pages/${id}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetWebsitePageQueryKey = (id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetWebsitePageParams>,) => {
    return [
    'website','pages',id, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWebsitePageQueryOptions = <TData = Awaited<ReturnType<typeof getWebsitePage>>, TError = ErrorType<void>>(id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetWebsitePageParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsitePage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetWebsitePageQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebsitePage>>> = ({ signal }) => getWebsitePage(id,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebsitePage>>, TError, TData>
}

export type GetWebsitePageQueryResult = NonNullable<Awaited<ReturnType<typeof getWebsitePage>>>
export type GetWebsitePageQueryError = ErrorType<void>


/**
 * @summary Page Details
 */

export function useGetWebsitePage<TData = Awaited<ReturnType<typeof getWebsitePage>>, TError = ErrorType<void>>(
 id: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<GetWebsitePageParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebsitePage>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebsitePageQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Page
 */
export const updateWebsitePage = (
    id: MaybeRefOrGetter<string>,
    websitePageInput: MaybeRefOrGetter<WebsitePageInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
websitePageInput = toValue(websitePageInput);

      return axiosClient<WebsitePage>(
      {url: `/website/pages/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: websitePageInput, signal
    },
      );
    }




export const getUpdateWebsitePageMutationKey = () => ['updateWebsitePage'] as const;

export const getUpdateWebsitePageMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWebsitePage>>, TError,UpdateWebsitePageMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateWebsitePage>>, TError,UpdateWebsitePageMutationVariables, TContext> => {

const mutationKey = getUpdateWebsitePageMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWebsitePage>>, UpdateWebsitePageMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateWebsitePage(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateWebsitePageMutationResult = NonNullable<Awaited<ReturnType<typeof updateWebsitePage>>>
    export type UpdateWebsitePageMutationBody = WebsitePageInput
    export type UpdateWebsitePageMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateWebsitePageMutationVariables = {id: string;data: WebsitePageInput}

    /**
 * @summary Update Page
 */
export const useUpdateWebsitePage = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateWebsitePage>>, TError,UpdateWebsitePageMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateWebsitePage>>,
        TError,
        UpdateWebsitePageMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateWebsitePageMutationOptions(options), queryClient);
    }
